export const TRANSFER_GRASP_TABLE_PAGE_SIZE = 20;
